import React from "react";
import { INPUT_INFO_ICON } from "../../utils/app-image-contant";
import { Tooltip } from "react-tooltip";

const NumberInput = ({
  name = "phoneNumber",
  labelName = "Phone Number",
  value,
  maxLength = "10",
  placeholder = "Enter Your Number",
  mandatory = true,
  error = false,
  handleInfoClick = function o() { },
  labelClass = "",
  handleChange = function o() { },
  info_popup_Icon = false,
  disabled = false,
  id = "",
  tooltipContent = "",
  textForUserinfo = "",
  NumberClass=""
}) => {
  
  const onInputChange = (e, max) => {
    let { value } = e.target;
    if (value.length > max) {
      e.target.value = value.slice(0, max);
    }
  };
  const handleRegisterKeyDown = (e) => {
    if (
      e.key === "e" ||
      e.key === "-" ||
      e.key === "+" ||
      e.key === "`" ||
      e.key === "E"
    ) {
      return e.preventDefault();
    }
  };

  return (
    <>
      <label className={`form-label ${labelClass}`}>{labelName}</label>{" "}
      <span className="textForUserinfo">
        {textForUserinfo && `(${textForUserinfo})`}
        {mandatory && <span className="text-red">* </span>}
      </span>
      <div className="input-relative">
        <input
          type="number"
          disabled={disabled}
          className={`form-control inputText ${error && "border-danger bg-error"
            } ${NumberClass && "Number_Input_class"
            }`}
          name={name}
          placeholder={placeholder}
          maxLength={maxLength}
          value={value}
          onChange={(e) => handleChange(e)}
          onKeyDown={(e) => handleRegisterKeyDown(e)}
          onInput={(e) => onInputChange(e, maxLength)}
          onWheel={(e) => e.target.blur()}
        />
        {info_popup_Icon && (
          <>
            <a
              data-tooltip-id={id}
              data-tooltip-content={tooltipContent}
              data-tooltip-place="top"
              className="tooltip-content"
            >
              <img
                src={INPUT_INFO_ICON}
                className="input-right-icon"
                alt="info-icon"
                width="18px"
                data-bs-toggle="modal"
                data-bs-target="#exampleModal_1"
                onClick={handleInfoClick}
              />
            </a>
            <Tooltip id={id} className="example-pink" />
          </>
        )}
        {/* {info_popup_Icon && (
          <img
            src={INPUT_INFO_ICON}
            className="input-right-icon cursor-pointer"
            alt="info-icon"
            width="18px"
            data-bs-toggle="modal"
            data-bs-target="#exampleModal"
            onClick={handleInfoClick}
          />
        )} */}
      </div>
    </>
  );
};

export default NumberInput;
